const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsMaria = { name: 'mar.ia', pathName: null, action: 'maria' }
const breadcrumbsMariaCampaign = { name: 'Campanha da mar.ia', pathName: '/maria/campanha-da-maria' }

export default [
  {
    path: '/maria',
    component: () => import('@/modules/maria/views/pages/Maria.vue'),
    meta: {
      title: 'mar.ia',
    },
    children: [
      {
        path: 'quando-vou-vender',
        component: () => import('@/modules/maria/views/pages/MariaSales.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMaria,
            {
              name: 'Previsão de vendas clube',
              pathName: null,
            },
          ],
          title: 'Previsão de vendas clube',
          pagePermission: 'maria/quando-vou-vender',
        },
      },
      {
        path: 'produtos-impulsionadores',
        name: 'produtosImpulsionares',
        component: () => import('@/modules/maria/produtos-impulsionadores/views/pages/WantSell.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMaria,
            {
              name: 'Produtos impulsionadores',
              pathName: null,
            },
          ],
          title: 'Produtos impulsionadores',
          pagePermission: 'maria/produtos-impulsionadores',
        },
      },
      {
        path: 'campanha-da-maria',
        name: 'maria-campaign',
        component: () => import('@/modules/maria/campanha-da-maria-v2/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsMaria, breadcrumbsMariaCampaign],
          title: 'Campanha da mar.ia',
          pagePermission: 'maria/campanha-da-maria',
        },
      },
      {
        path: 'campanha-da-maria/nova',
        name: 'new-maria-campaign',
        component: () => import('@/modules/maria/campanha-da-maria-v2/views/pages/Edit.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMaria,
            breadcrumbsMariaCampaign,
            {
              name: 'Nova campanha da mar.ia',
              pathName: null,
            },
          ],
          title: 'Nova campanha da mar.ia',
          pagePermission: 'maria/campanha-da-maria',
        },
      },
      {
        path: 'campanha-da-maria/editar/:id',
        name: 'edit-maria-campaign',
        component: () => import('@/modules/maria/campanha-da-maria-v2/views/pages/Edit.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMaria,
            breadcrumbsMariaCampaign,
            {
              name: 'Editar campanha da mar.ia',
              pathName: null,
            },
          ],
          title: 'Editar campanha da mar.ia',
          pagePermission: 'maria/campanha-da-maria',
        },
      },
      {
        path: 'campanha-da-maria/visualizar/:id',
        name: 'view-maria-campaign',
        component: () => import('@/modules/maria/campanha-da-maria-v2/views/pages/Edit.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMaria,
            breadcrumbsMariaCampaign,
            {
              name: 'Visualizar campanha da mar.ia',
              pathName: null,
            },
          ],
          title: 'Visualizar campanha da mar.ia',
          pagePermission: 'maria/campanha-da-maria',
        },
      },
      {
        path: 'campanha-da-maria/resultados/:id',
        name: 'results-maria-campaign',
        component: () => import('@/modules/maria/campanha-da-maria-v2/views/pages/Results.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMaria,
            breadcrumbsMariaCampaign,
            {
              name: 'Resultados',
              pathName: null,
            },
          ],
          title: 'Resultados da campanha da mar.ia',
          pagePermission: 'maria/campanha-da-maria',
        },
      },
    ],
  },
]
